/**
 * The customer app's origin, or null when it is not configured or not http(s).
 * Parsed rather than concatenated so a malformed value cannot become a
 * `javascript:` href.
 */
export function customerAppUrl(base: string | undefined): string | null {
  if (!base) return null;
  try {
    const url = new URL(base);
    if (url.protocol !== "https:" && url.protocol !== "http:") return null;
    return url.toString();
  } catch {
    return null;
  }
}
